import React from 'react';
import {
  Box, Button, IconButton, Paper, Skeleton, Tab, Table, TableBody, TableCell, TableContainer,
  TableHead, TablePagination, TableRow, Tabs, Tooltip,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import StatusChip from '../../Common/StatusChip';
import EmptyState from '../../Common/EmptyState';

const SKELETON_ROWS = 5;

const FILTERS = ['pending', 'approved', 'partial', 'rejected', 'all'];

const RequestTable = ({ requests, loading, filter, onFilterChange, onReview, onEditAccess, page, rowsPerPage, total, onPageChange, onRowsPerPageChange }) => (
  <Box>
    <Tabs
      value={filter}
      onChange={(_, v) => onFilterChange(v)}
      sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
    >
      {FILTERS.map((f) => (
        <Tab key={f} value={f} label={f} sx={{ textTransform: 'capitalize' }} />
      ))}
    </Tabs>

    {!loading && requests.length === 0 ? (
      <EmptyState
        title={`No ${filter !== 'all' ? filter : ''} requests`}
        message="Nothing to show for this filter."
      />
    ) : (
      <>
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead sx={{ bgcolor: 'grey.50' }}>
              <TableRow>
                <TableCell>User</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Demos Requested</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Submitted</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading
                ? Array.from({ length: SKELETON_ROWS }).map((_, i) => (
                    <TableRow key={i}>
                      <TableCell><Skeleton variant="text" width="70%" /></TableCell>
                      <TableCell><Skeleton variant="text" width="85%" /></TableCell>
                      <TableCell><Skeleton variant="text" width={24} /></TableCell>
                      <TableCell><Skeleton variant="rounded" width={72} height={22} /></TableCell>
                      <TableCell><Skeleton variant="text" width="60%" /></TableCell>
                      <TableCell align="right"><Skeleton variant="rounded" width={80} height={28} /></TableCell>
                    </TableRow>
                  ))
                : requests.map((req) => (
                    <TableRow key={req.request_id} hover>
                      <TableCell>{req.user_name || '—'}</TableCell>
                      <TableCell>{req.user_email || '—'}</TableCell>
                      <TableCell>{(req.requested_demo_ids ?? []).length}</TableCell>
                      <TableCell>
                        <StatusChip status={req.status} />
                      </TableCell>
                      <TableCell>
                        {req.requested_at
                          ? new Date(req.requested_at).toLocaleDateString()
                          : '—'}
                      </TableCell>
                      <TableCell align="right" sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 0.5 }}>
                        {req.status === 'pending' ? (
                          <Button
                            size="small"
                            startIcon={<VisibilityIcon />}
                            onClick={() => onReview(req)}
                          >
                            Review
                          </Button>
                        ) : (
                          <Tooltip title="Modify Access">
                            <IconButton size="small" onClick={() => onEditAccess(req)}>
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={total}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </>
    )}
  </Box>
);

export default RequestTable;
